import React, { useEffect, useState } from "react";
import {
  transformResultsToCompProfileData,
  formatBoldText,
  checkColumns,
} from "../../../../../services/commonService";
import InsightTable from "../../InsightTable";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";
import { useParams } from "react-router-dom";

function CustomerSegmentAnalysis({ customerSegmentAnalysis, compView }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");
  const { clientName, competitorName } = useParams();

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        // { key: "customer_segment", label: "Customer Segment" },
        { key: "market_position", label: "Market Position", width: "150px" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        // { key: "customer_segment", label: "Customer Segment" },
        { key: "market_position", label: "Market Position", width: "150px" },
        { key: "top_use_cases", label: "Top Use Cases" },
        { key: "sample_applications", label: "Sample Applications" },
        {
          key: "key_pain_points",
          label: `Key Pain Points - Addressed by ${competitorName}`,
        },
        {
          key: "top_customer",
          label: "Top Customers",
        },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  const dummyData = [
    {
      customer_segment: {
        value: "Premium Commercial Contractors",
      },
      taylor_position: {
        value: "Market Leader",
      },
      top_use_cases: {
        value: "Large-scale flooring installations, green building projects",
      },
      sample_applications: {
        value: "Office complexes, retail spaces, LEED-certified buildings",
      },
      voice_of_customer: {
        value: `Limited global project support, Premium pricing pressure in competitive bids`,
      },
      top_customer_data_available: {
        value: "Not publicly available",
      },
    },
  ];

  useEffect(() => {
    // setTabData(dummyData);
    const transformed = transformResultsToCompProfileData(
      customerSegmentAnalysis
    );

    // Check if columns meet multiple conditions
    const columnConditions = {
      top_customer: ["notEqualToNA"],
    };

    if (checkColumns(Object.values(transformed), columnConditions)) {
      setHiddenColumns((prev) => [...prev, ...Object.keys(columnConditions)]);
    }
    setTabData(transformed);
    setTableBelowDescription(
      // formatBoldText(
      //   customerSegmentAnalysis?.[0]?.response?.["tableComments"]
      // )
      <ParsedTextWithLinks
        text={customerSegmentAnalysis?.[0]?.response?.["tableComments"] || ""}
      />
    );
  }, [customerSegmentAnalysis]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Customer Segment Analysis"
      subtitle=""
      // belowTableDescription={`The vulnerability hiding in plain sight: Taylor's customer concentration risk is more severe than anyone realizes - their top 3 customer segments (Premium Commercial, Green Building, Regional Mid-Market) represent approximately 85% [1][6] of revenue. But here's what's really alarming: their own customers are telling them the painful truth through complaints that reveal systematic vulnerabilities H.B. Fuller could exploit [6]. Global project support gaps, digital specification tool deficits, and financing inflexibility. Most telling? Even their loyal premium contractors are saying "price premium difficult to justify" [6] - suggesting margin pressure is building even in their stronghold segments.`}
      belowTableDescription={tableBelowDescription}
      data={tabData}
      metrics={columns}
      hiddenColumns={hiddenColumns}
      rowIdentifier="customer_segment"
      actions={actions}
    />
  );
}

export default CustomerSegmentAnalysis;
